import { render, staticRenderFns } from "./PacketizationDiagramConfigurator.vue?vue&type=template&id=239dda48&scoped=true&"
import script from "./PacketizationDiagramConfigurator.vue?vue&type=script&lang=ts&"
export * from "./PacketizationDiagramConfigurator.vue?vue&type=script&lang=ts&"
import style0 from "./PacketizationDiagramConfigurator.vue?vue&type=style&index=0&id=239dda48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239dda48",
  null
  
)

export default component.exports